// src/firebase-messaging-sw.js
import { firebaseConfig } from "./services/firebase";

if ("serviceWorker" in navigator) {
  const params = new URLSearchParams(firebaseConfig).toString();
  // Đăng ký ở root scope để nhận push trong mọi route
  navigator.serviceWorker
    .register(`/firebase-messaging-sw.js?${params}`, { scope: "/" })
    .then((registration) => {
      console.log("[FCM] SW registered:", registration.scope);
    })
    .catch((err) => {
      console.log("[FCM] SW registration failed:", err);
    });
}
